export default {
  customer: {
    dialog: {
      whatsApp: {
        needSupport: 'Need support? Scan the QR code with WhatsApp to contact us',
        saveTheQR: 'Save the QR code to album'
      },
      wechat: {
        needSupport: 'Need support?',
        withWeChat: 'Scan the QR code with WeChat to contact us',
        saveTheQR: 'Save the QR code to album'
      },
      facebook: {
        needSupport: 'Need support?',
        copyAccount: 'Copy the account ID',
        FacebookToContact: 'Seach  lavamusicofficial on Facebook Messenger to contact us'
      }
    }
  },
  chat_online: 'Online Service',
  wechat: 'WeChat',
  lava_support_team: 'LAVA Support Team'
}
